import { render, staticRenderFns } from "./DictRadioGroup.vue?vue&type=template&id=d08bc74c&scoped=true"
import script from "./DictRadioGroup.vue?vue&type=script&lang=js"
export * from "./DictRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08bc74c",
  null
  
)

export default component.exports